"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("../../locales/en-CA/index.json"));
var _index2 = _interopRequireDefault(require("../../locales/en-GB/index.json"));
var _index3 = _interopRequireDefault(require("../../locales/en-US/index.json"));
var _index4 = _interopRequireDefault(require("../../locales/es-ES/index.json"));
var _index5 = _interopRequireDefault(require("../../locales/es-US/index.json"));
var _index6 = _interopRequireDefault(require("../../locales/fr-CA/index.json"));
var _index7 = _interopRequireDefault(require("../../locales/fr-FR/index.json"));
var _default = exports.default = {
  'en-CA': _index.default,
  'en-GB': _index2.default,
  'en-US': _index3.default,
  'es-ES': _index4.default,
  'es-US': _index5.default,
  'fr-CA': _index6.default,
  'fr-FR': _index7.default
};